<template>
  <v-card
    class="mx-auto"
    flat
    outlined
    tile
  >
    <v-img
      class="white--text align-end"
      height="200px"
      src="../assets/vector_bg.svg"
    >
    <v-btn
      class="ma-4"
      fab
      x-large
      style="border: 3px solid grey"
    >
      <v-icon dark>
        fa fa-user
      </v-icon>
    </v-btn>
    </v-img>
    <v-card-title>Account</v-card-title>
    <v-tabs vertical v-model="tabs">
      <v-tab>
        <v-icon small left>
          fa fa-user
        </v-icon>
        Profile
      </v-tab>
      <v-tab>
        <v-icon small left>
          fa fa-key
        </v-icon>
        Security
      </v-tab>
<v-tab-item>
        <v-card flat max-width="600">
          <v-overlay
          :absolute="true"
          :value="overlay"
        >
            <v-progress-circular
        indeterminate
        color="primary"
        ></v-progress-circular>
        </v-overlay>
          <v-card-text class="mt-0 pt-0">
            <v-row v-if="!isCorporate">
            <v-col cols="12" md="12">
                        <v-text-field
                            dense
                            outlined
                            type="text"
                            v-model="items.name.item"
                            label="Name"
                            disabled
                            required
                            background-color="white"
                            hide-details="auto"
                            autocomplete="off"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" v-if="items.mobile.isMobile">
                        <v-text-field
                            dense
                            outlined
                            type="text"
                            v-model="items.mobile.item"
                            label="Mobile No."
                            disabled
                            required
                            background-color="white"
                            hide-details="auto"
                            autocomplete="off"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12">
                        <v-text-field
                            dense
                            outlined
                            type="text"
                            v-model="user"
                            label="Email"
                            disabled
                            required
                            background-color="white"
                            hide-details="auto"
                            autocomplete="off"
                        ></v-text-field>
                    </v-col>
            </v-row>
        <v-form ref="sf" action="#" @submit.prevent="validateBeforeSubmitProfile" lazy-validation v-if="isCorporate">
          <v-row>
            <v-col cols="12" md="12">
                        <v-text-field
                            dense
                            outlined
                            type="text"
                            v-model="items.accid.item"
                            label="Account ID"
                            required
                            background-color="white"
                            hide-details="auto"
                            autocomplete="off"
                            disabled
                        ></v-text-field>
                    </v-col>
            <v-col cols="12" md="12">
                        <v-text-field
                            dense
                            outlined
                            type="text"
                            v-model="items.corporatename.item"
                            :rules="items.corporatename.rule"
                            label="Corporate Name"
                            required
                            background-color="white"
                            hide-details="auto"
                            autocomplete="off"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12">
                        <v-text-field
                            dense
                            outlined
                            type="text"
                            v-model="user"
                            label="Email"
                            required
                            background-color="white"
                            hide-details="auto"
                            autocomplete="off"
                            disabled
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12">
                        <v-text-field
                            dense
                            outlined
                            type="text"
                            v-model="items.picname.item"
                            :rules="items.picname.rule"
                            label="PIC Name"
                            required
                            background-color="white"
                            hide-details="auto"
                            autocomplete="off"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12">
                        <v-text-field
                            dense
                            outlined
                            type="text"
                            v-model="items.piccontact.item"
                            :rules="items.piccontact.rule"
                            label="PIC Contact No."
                            placeholder="60123456789"
                            required
                            background-color="white"
                            hide-details="auto"
                            autocomplete="off"
                        ></v-text-field>
                    </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn outlined color="#FFD100" small style="background: black" type="submit" :loading="loading" :disabled="loading" class="mt-2"> Save <template v-slot:loader>
                  <span>Loading...</span>
                </template>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
    </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat max-width="600">
          <v-card-text class="mt-0 pt-0">
        <v-form ref="es" action="#" @submit.prevent="validateBeforeSubmit" lazy-validation>
          <v-row>
            <v-col cols="12">
              <v-text-field :append-icon="user.show3 ? 'mdi-eye' : 'mdi-eye-off'" :type="user.show3 ? 'text' : 'password'" @click:append="user.show3 = !user.show3" required :rules="rules3" v-model="user.currentpassword" light="light" hide-details="auto" outlined dense label="Current Password"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field :append-icon="user.show ? 'mdi-eye' : 'mdi-eye-off'" :type="user.show ? 'text' : 'password'" @click:append="user.show = !user.show" required :rules="rules1" v-model="user.password" light="light" hide-details="auto" outlined dense label="Password"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field :append-icon="user.show2 ? 'mdi-eye' : 'mdi-eye-off'" :type="user.show2 ? 'text' : 'password'" @click:append="user.show2 = !user.show2" required :rules="rules2" v-model="user.cpassword" light="light" label="Confirm Password" hide-details="auto" outlined dense></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn outlined color="#FFD100" small style="background: black" type="submit" :loading="loading" :disabled="loading" class="mt-2"> Change Password <template v-slot:loader>
                  <span>Loading...</span>
                </template>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
    </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>
    <v-snackbar
        v-model="swal.notification"
        top
        :color="swal.scolor"
        >
        {{ swal.message }}
    </v-snackbar>
    <alertbox :dialog="ma.alertmodal" :customText="ma.customText" :modal_action_type="ma.modal_action_type" :modalInfo="ma.modalInfo" @confirm="onConfirm" @closed="onClosed"></alertbox>
  </v-card>
</template>

<script>
import alertbox from '../components/modals/Alert';
import {ERR} from '../assets/js/errhandle.js';

export default {
    name: 'Account',
    title: 'Account',

    data: () => ({
        loading: false,
        options: {
                isLoggingIn: '',
                shouldStayLoggedIn: true,
            },

        user: {
            currentpassword: '',
            password: '',
            cpassword: '',
            show: false,
            show2: false,
            show3: false
        },
        items: {
          corporatename: {item: '', rule: []},
          picname: {item: '', rule: []},
          piccontact: {item: '', rule: []},
          name: {item: ''},
          email: {item: ''},
          accid: {item: ''},
          mobile: {item: '', isMobile: false}
        },
        rules1: [],
        rules2: [],
        rules3: [],

        btn_loading: false,
        dialog: false,
        toaster: false,
        toastertxt: '',
        toasterColor: '',
        ma: {
            modalInfo: [],
            alertmodal: false,
            modal_action_type: ''
        },
        swal: {
            notification: false,
            message: '',
            scolor: '',
        },
        tabs: 0,
        overlay: false,
        user: localStorage.getItem('user'),
        displayname: '',
        isCorporate: false
    }),

    components: {alertbox},

    async mounted () {
        await this.initItems();
        this.clearRules();
        this.listCorporateInfo();
    },

    computed: {
      confirmPword(){
        if (this.user.password !== this.user.cpassword){
            return false;
        }

        else{
            return true;
        }
     }
    },

    watch: {
        'tabs': {
        handler: function(value) {
            this.clearRules();
            this.user.currentpassword = '';
            this.user.password = '';
            this.user.cpassword = '';
        }
        }
    },

    methods: {
        async listCorporateInfo(){
            this.overlay = true;
            let response = await this.$store.dispatch('getCorporateInfo', {})
            if (response.data.code == 'AP000'){
                let dt = response.data.record;
                this.items.corporatename.item = dt.CorporateName;
                this.items.picname.item = dt.PICName;
                this.items.piccontact.item = dt.PICContact;
                this.items.accid.item = dt.CorporateAccountID;
            }

            this.overlay = false;
        },

        initItems(){
        this.isCorporate = false;
        let dt = this.$store.getters.getSystem;
        let newarr = [];

                let isMobileLinked = dt.some(item => item.Type === 1 && item.Role === 1);
                let isCorporateLinked = dt.some(item => item.Type === 1 && item.Role === 2);

                if (!isMobileLinked){
                    newarr.push({
                        Type: 1,
                        Role: 1,
                        fontclass: 'fa fa-user-plus',
                        color: '#FBCE07',
                        DisplayName: "Link to Snatch Mobile App",
                        islinked: false
                    });
                }

                else{
                    let mobileitem = dt.find(item => item.Type === 1 && item.Role === 1);
                    mobileitem.fontclass = 'fa fa-user';
                    mobileitem.color = '#FBCE07';
                    mobileitem.islinked = true;
                    mobileitem.title = "Subscriber Account";
                    mobileitem.displayname = mobileitem.DisplayName;
                    newarr.push(mobileitem);
                }

                if (!isCorporateLinked){
                    newarr.push({
                        Type: 1,
                        Role: 2,
                        fontclass: 'fa fa-user-plus',
                        color: '#ADABB0',
                        DisplayName: "Add Corporate Profile",
                        islinked: false
                    });
                }

                else{
                    let corporateitem = dt.find(item => item.Type === 1 && item.Role === 2);
                    corporateitem.fontclass = 'fa fa-user';
                    corporateitem.color = '#ADABB0';
                    corporateitem.islinked = true;
                    corporateitem.title = "Subscriber Account";
                    corporateitem.displayname = corporateitem.CorporateName;
                    newarr.push(corporateitem);
                }

                for(var i=0; i<dt.length; i++){
                    if ( (dt[i].Type !== 1 && dt[i].Role !== 1) || (dt[i].Type !== 1 && dt[i].Role !== 2) )
                    newarr.push({
                        Type: dt[i].Type,
                        Role: dt[i].Role,
                        fontclass: 'fa fa-user',
                        color: '#427AB3',
                        title: 'Operator Account',
                        Operator: dt[i].Operator,
                        Carpark: dt[i].Carpark,
                        ProfileType_Name: dt[i].ProfileType_Name,
                        ProfileRole_Name: dt[i].ProfileRole_Name,
                        OperatorIDCheckList: dt[i].OperatorIDCheckList,
                        ProfileTRSOC: dt[i].ProfileTRSOC,
                        DisplayMobile: dt[i].DisplayMobile,
                        DisplayName: dt[i].DisplayName,
                        displayname: dt[i].OperatorUserName || 'N/A',
                        islinked: true
                    });
                }

                let a = newarr.find(this.checkItem)
                console.log('a', a);
                this.items.name.item = a.displayname == "" || a.displayname == null ? "N/A" : a.displayname;
                if (a.Type == 1 && a.Role == 2){
                  this.isCorporate = true;
                }
                if (a.Type == 1 && a.Role == 1){
                  this.items.mobile.item = a.DisplayMobile == "" || a.DisplayMobile == null ? "N/A" : a.DisplayMobile;
                  this.items.mobile.isMobile = true;
                }
      },

      checkItem(item){
        let a = typeof item.ProfileTRSOC;
        if (a != 'undefined'){
          return item.ProfileTRSOC.replaceAll('|', '').replace('#', ',') == localStorage.getItem('perm');
        }

        else{
          return false;
        }
      },

        clearRules(){
          this.rules1 = [];
          this.rules2 = [];
          this.rules3 = [];
        },

        async validateBeforeSubmit(){
            this.clearRules();

            this.rules1 = [
                v => !!v || 'Password is required'
            ];

            this.rules2 = [
                v => !!v || `This is required`,
                v => this.confirmPword || 'Please ensure your password matches',
            ];

            this.rules3 = [
                v => !!v || 'Password is required',
            ];

            //must set this in order to use 'this' as 'self' inside settimeout etc..
            let self = this;

            setTimeout(function () {
                //self.$refs.image.resetValidation();
                //self.$refs.image.reset();

             if (self.$refs.es.validate()) {
                    self.ma.alertmodal = true;
                    self.ma.modalInfo = {type: 'changepassword'};
                    self.ma.modal_action_type = 'update';
                }
            });
        },

        async validateBeforeSubmitProfile(){
            this.clearRules();

            this.items.corporatename.rule = [
                v => !!v || 'This is required'
            ];

            this.items.picname.rule = [
                v => !!v || 'This is required'
            ];

            this.items.piccontact.rule = [
                v => !!v || 'This is required',
                v => !v || /^(6{1}0)[0-9]{1,2}[0-9]{7,8}$/.test(v) || 'Please enter a valid phone no.'
            ];

            //must set this in order to use 'this' as 'self' inside settimeout etc..
            let self = this;

            setTimeout(function () {
                //self.$refs.image.resetValidation();
                //self.$refs.image.reset();

             if (self.$refs.sf.validate()) {
                    self.ma.alertmodal = true;
                    self.ma.modalInfo = {type: 'updateprofile'};
                    self.ma.modal_action_type = 'update';
                }
            });
        },

        async changePassword(){
            this.btn_loading = true;
            this.loading = true;
            let req = {currentpassword: this.user.currentpassword, newpassword: this.user.password, confirmnewpassword: this.user.cpassword};
            try{
                let response = await this.$store.dispatch("changeMyPassword", req);
                if (response.data.code === 'AP000'){
                    this.swal.notification = true;
                    this.swal.scolor = 'green';
                    this.swal.message = `${ERR.HANDLE(response.data.code)}: Password Changed!`;
                    //this.$router.push({ name: 'Car Park Rate', query: {created: true, carpark: this.form.carpark.selected}});
                }

                else if (response.data.code === 'RD002'){
                    this.swal.notification = true;
                    this.swal.scolor = 'red';
                    this.swal.message = `${ERR.HANDLE(response.data.code)}: Please ensure you remember your current password before attempting to change it.`;
                }

                else{
                    this.loading = false;
                    this.swal.notification = true;
                    this.swal.scolor = 'red';
                    this.swal.message = `${ERR.HANDLE(response.data.code)}`;
                }

                this.loading = false;
                this.btn_loading = false;
            }

            catch(err){
                console.log(err);
                this.swal.notification = true;
                this.swal.scolor = 'red';
                this.swal.message = 'Something went wrong. Please try again later';
                this.loading = false;
                this.btn_loading = false;
            }
        },

        async updateProfile(){
            this.btn_loading = true;
            this.loading = true;
            let req = {corporatename: this.items.corporatename.item, picname: this.items.picname.item, piccontact: this.items.piccontact.item};
            try{
                let response = await this.$store.dispatch("updateCorporateProfile", req);
                if (response.data.code === 'AP000'){
                    this.swal.notification = true;
                    this.swal.scolor = 'green';
                    this.swal.message = `${ERR.HANDLE(response.data.code)}: Profile Updated!`;
                    //this.$router.push({ name: 'Car Park Rate', query: {created: true, carpark: this.form.carpark.selected}});
                }

                else{
                    this.loading = false;
                    this.swal.notification = true;
                    this.swal.scolor = 'red';
                    this.swal.message = `${ERR.HANDLE(response.data.code)}`;
                }

                this.loading = false;
                this.btn_loading = false;
            }

            catch(err){
                console.log(err);
                this.swal.notification = true;
                this.swal.scolor = 'red';
                this.swal.message = 'Something went wrong. Please try again later';
                this.loading = false;
                this.btn_loading = false;
            }
        },

        onConfirm(){
            this.ma.alertmodal = false;
            if (this.ma.modalInfo.type == 'changepassword')
            this.changePassword();

            if (this.ma.modalInfo.type == 'updateprofile')
            this.updateProfile();
        },

        onClosed(){
            this.ma.alertmodal = false;
        },

        changeOrder(e) {
            e.preventDefault();
            e.stopPropagation();
        },
    }
    
}
</script>